const ACTIVE_JOB_STATUSES = new Set(["pending", "processing", "starting"]);
const TERMINAL_JOB_STATUSES = new Set(["completed", "failed"]);

export function mergeActiveJobs(currentJobs = [], returnedJobs = []) {
  const returnedIds = new Set(returnedJobs.map((job) => String(job.id)));
  const preserved = currentJobs.flatMap((job) => {
    if (returnedIds.has(String(job.id))) return [];
    if (TERMINAL_JOB_STATUSES.has(job.status)) return [job];
    if (
      ACTIVE_JOB_STATUSES.has(job.status)
      && Number(job.missingActivePolls || 0) < 2
    ) {
      // /active can drop a job just before /status reports its terminal state.
      return [{ ...job, missingActivePolls: Number(job.missingActivePolls || 0) + 1 }];
    }
    return [];
  });

  return [
    ...returnedJobs.map(({ missingActivePolls: _missingActivePolls, ...job }) => job),
    ...preserved,
  ];
}

export function mergeJobStatusUpdates(currentJobs = [], returnedJobs = []) {
  const updates = new Map(returnedJobs
    .filter(Boolean)
    .map((job) => [String(job.id), job]));
  if (updates.size === 0) return currentJobs;
  return currentJobs.map((job) => updates.has(String(job.id))
    ? { ...job, ...updates.get(String(job.id)), missingActivePolls: 0 }
    : job);
}
